import React from "react";
import {ListInfo} from "../../Components/ListInfo/ListInfo";

const Contact = () => {
    return(
        <div>
            <ListInfo urlName={'contact'}/>
        </div>
    )
};

export {Contact};